import React from "react";
import { Link } from "react-router-dom";

function createDynamicTag(tagName, props, children) {
    const Tag = tagName;
  
    return <Tag {...props}>{children}</Tag>;
  }
  function create_list_ptag(item){
    let tag_data;
    let tag_inner;
    if(item.other_option != undefined){
     let innerItem =  item.other_option ;
    
     innerItem.forEach((itemchild, index) => {
      tag_inner = createDynamicTag(itemchild.tag_name,itemchild.props_data,itemchild.title);
      tag_inner = (<>{itemchild.contain_before}{tag_inner}{itemchild.contain_after}</>)
      tag_data = (<>{tag_data}{tag_inner}</>);
  });
    }
   let all_data = item.title;
  
   return (
    <>
        {all_data} {tag_data}
    </>
  );
  }
const Banner = ({bannerdata}) => {
    let container;
    if(bannerdata.contentClass == undefined){
        container = 'container';
    }else{
        container = 'container '+bannerdata.contentClass;
    }
                

  return (
    <section>
        <section className="breadcumb-section">
    <div className="container">
        <div className="breadcumb-title text-center">
            <h1>{bannerdata.titleone}</h1>
        </div>
    </div>
</section>
{!bannerdata.img ? '' : 
<section className="about-content-section">
    <div className={container} >
        <div className="about-content-wrapper d-flex justify-content-between align-items-center">
            <div className="about-image">
                
                <img src={bannerdata.img} alt="" className=""/>
            </div>
            <div className="about-content">
                <h2>{bannerdata.titletwo}</h2>
                {Array.isArray(bannerdata.textone) ? bannerdata.textone.map((item, index) => (
            <p key={index} > {create_list_ptag(item)}</p>
         )) : <p>{bannerdata.textone}</p>}
                <p><strong>{bannerdata.texttwo}</strong> {bannerdata.textthree}</p>
                
        </div>
    </div>
    </div>
</section>}
    </section>
  );
};

export default Banner;